import styled from "styled-components";
import CommonModal from "../based/Modal";
import Common from "../based/Common";
import { useContext, useEffect, useState } from "react";
import { InvoiceManagementContext } from "./InvoiceManagementProvider";
import InvoiceServices from "../based/services/InvoiceServices";
import { Notify } from "../based/Notify";
import { NOTIFY } from "../based/Constants";

function ConfirmReleaseModal({ show, onClose, originalInvoiceId, onSucceed }) {
    const { showDetail, setShowDetail, showConfirmRelease, setShowConfirmRelease, showEditInvoice, setShowEditInvoice, showReasonModal, setShowReasonModal } = useContext(InvoiceManagementContext);
    const [busy, setBusy] = useState(false);
    const [model, setModel] = useState({});

    useEffect(() => {
        if (originalInvoiceId) {
            getData(originalInvoiceId);
        }
    }, [originalInvoiceId]);

    const getData = async (originalInvoiceId) => {
        setBusy(true);
        const [err, data] = await InvoiceServices.GetInfoHistoryById(originalInvoiceId);
        if (!err && data) {
            setModel(data);
        } else {
            setModel({});
        }
        setBusy(false);
    };

    const publishInvoice = async (originalInvoiceId) => {
        setBusy(true);
        const [err, data] = await InvoiceServices.PublishInvoice(originalInvoiceId);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Tạo hóa đơn thành công");
            setShowConfirmRelease(false);
            setShowDetail(false);
            onSucceed();
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Tạo hóa đơn thất bại");
        }
        setBusy(false);
    };

    if (!model || !model.id) return null;
    return (
        <CommonModal show={show} onClose={onClose} title="Xác nhận đã phát hành hóa đơn" hideOnClose isBusy={busy} busyMsg="Đang xử lý">
            <Wrapper>
                {model.taxCode ? (
                    <div className="confirm_release_address">
                        <div className="confirm_release_address-line">
                            <div className="left-line">
                                <span>Cty</span>
                            </div>
                            <div className="right-line">
                                <span>{model.companyName}</span>
                            </div>
                        </div>
                        <div className="confirm_release_address-line">
                            <div className="left-line">
                                <span>MST</span>
                            </div>
                            <div className="right-line">
                                <span>{model.taxCode}</span>
                            </div>
                        </div>
                        <div className="confirm_release_address-line">
                            <div className="left-line">
                                <span>Đc</span>
                            </div>
                            <div className="right-line">
                                <span>{model.address}</span>
                            </div>
                        </div>
                        <div className="confirm_release_address-line">
                            <div className="left-line">
                                <span>Email</span>
                            </div>
                            <div className="right-line">
                                <span>{model.email}</span>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="confirm_release_address">
                        <div className="confirm_release_address-line">
                            <div className="left-line">
                                <span>Nội dung</span>
                            </div>
                            <div className="right-line">
                                <span>KHÁCH KHÔNG LẤY HÓA ĐƠN</span>
                            </div>
                        </div>
                    </div>
                )}

                <div className="confirm_release_total">
                    <div className="confirm_release_total-line">
                        <div className="left-line">
                            <span>Tổng trước thuế</span>
                        </div>
                        <div className="right-line">
                            <span>{Common.formatCurrency(model.totalAmountWithoutTax)}</span>
                        </div>
                    </div>
                    <div className="confirm_release_total-line">
                        <div className="left-line">
                            <span>Tổng thuế 8%</span>
                        </div>
                        <div className="right-line">
                            <span>{Common.formatCurrency(model.taxAmount)}</span>
                        </div>
                    </div>
                    <div className="confirm_release_total-line">
                        <div className="left-line">
                            <span>Tổng tiền sau thuế</span>
                        </div>
                        <div className="right-line">
                            <span>{Common.formatCurrency(model.totalAmount)}</span>
                        </div>
                    </div>
                </div>
                <div className="confirm_release_bottom">
                    <div className="lst-button">
                        <button
                            className="btn btn-danger"
                            onClick={(e) => {
                                setShowConfirmRelease(false);
                            }}
                        >
                            Đóng
                        </button>
                        <button
                            className="btn btn-custom"
                            onClick={(e) => {
                                publishInvoice(model.id);
                            }}
                        >
                            Đồng ý
                        </button>
                    </div>
                </div>
            </Wrapper>
        </CommonModal>
    );
}

export default ConfirmReleaseModal;

const Wrapper = styled.div`
    .confirm_release_address-line {
        display: flex;
        align-items: center;
        margin: 2px 0px;
    }

    .confirm_release_address-line .left-line {
        color: #666f7b;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        width: 100px;
    }

    .confirm_release_address-line .right-line {
        flex: 1;
    }

    .confirm_release_total-line {
        display: flex;
        align-items: center;
        margin: 2px 0;
    }

    .confirm_release_total {
        margin: 8px 0;
    }

    .confirm_release_total-line .left-line {
        color: #666f7b;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .confirm_release_total-line .right-line {
        margin-left: auto;
    }

    .lst-button {
        display: flex;
        justify-content: space-around;
    }

    .lst-button button {
        width: 45%;
    }
`;
